export const PAGE_NAME = "Reducera";
export const BASE_URL = "https://reducera.app";
export * from "./page-title";
